import { Injectable } from '@angular/core';
import { INotification } from './notification-factory.service';
import { PushNotificationService } from './push-notification.service';
import { MessageTemplate } from '../../models/enums/enums';

@Injectable({
  providedIn: 'root'
})
export class DocumentRequestedNotificationService implements INotification {
  constructor(
    private pushNotificationService: PushNotificationService
  ) { }

  notify(message: string, data: { [key: string]: any }): void {
    // We pass the data to the push notification service which handles the display
    // The route will be determined by the pushNotificationService based on the template
    this.pushNotificationService.pushNotification(message, MessageTemplate.DocumentRequested, data);
  }
}
